__webpack_require__.p = "https://cdn.dgtalguide.com/web/bundles/d5b3f67/";